import React from 'react'
import GridLayout from '@toasttab/shared/src/components/organisms/Grid/GridLayout/GridLayout'
import GridColumn from '@toasttab/shared/src/components/organisms/Grid/GridColumn/GridColumn'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import Byline from '@toasttab/otl/src/components/Byline/Byline'
import { HeroProps } from '@toasttab/otl/src/components/MDS/Hero/Hero.d'

const Hero = ({
  heading,
  description,
  heroImage,
  author,
  expertReviewer
}: HeroProps) => {
  return (
    <section className='ds-wrapper ds-container mt-2.5 md:mt-8 md:mb-8 pb-6 md:pb-8 md:border-b md:border-gray-30'>
      <GridLayout gap='mds'>
        <GridColumn
          columnSpan={['col-span-4', 'md:col-span-3', 'lg:col-span-12']}
          columnStart={['lg:col-start-1']}
          columnEnd={['lg:col-end-6']}
          classes='block order-last mb-4 md:flex md:self-center md:order-first md:w-[290px] md:!h-[294px] lg:w-[458px] lg:!h-[312px]'
        >
          {heroImage.src && (
            <picture className=''>
              <source
                srcSet={heroImage.src}
                itemProp='image'
                title={heroImage.title}
              />
              <source srcSet={heroImage.avif} sizes='100vw' type='image/avif' />
              <img
                src={heroImage.src}
                alt={heroImage.title}
                itemProp='image'
                className='lazyload w-full object-cover h-full max-w-full rounded-lg'
              />
            </picture>
          )}
        </GridColumn>
        <GridColumn
          columnSpan={['col-span-4', 'md:col-span-3', 'lg:col-span-12']}
          columnStart={['lg:col-start-6']}
          columnEnd={['lg:col-end-12']}
          classes='order-first md:order-last md:-ml-8 lg:ml-4 pt-0 lg:py-12'
        >
          <Typography
            variation='h1'
            as='h1'
            classes='text-[2.5rem] leading-[2.5rem] md:text-[3rem] md:leading-[3rem] font-gliko mb-4'
            allowHtml={false}
          >
            {heading}
          </Typography>
          <Typography
            variation='default'
            as='p'
            classes='hidden md:block mb-4 text-default text-[20px] font-sansPro'
            allowHtml={false}
          >
            {description}
          </Typography>
          <Byline author={author} reviewer={expertReviewer} />
        </GridColumn>
      </GridLayout>
    </section>
  )
}

export default Hero
